;
( function( $, window, document, undefined )
{
    'use strict';

    var BoardHero = function( element, options )
    {
        this.els = options.els;

        this.init();
    };

    BoardHero.prototype = {

        init : function()
        {
            this.collapsePopularTopics();
            this.dropdownAllTopics();
            this.mobileDropdown();
            this.mobileOptions();
        },

        mobileOptions: function () {
            var heroType = $('#theHero').attr('class').replace('image-wrap', '').replace('copy-indent', '').replace('banner_short', '').replace('custom-board-hero', '').replace('collapsed', '');
            $('#dropDownLink').addClass(heroType).html('<span><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="32" height="32" viewBox="0 0 16 16"><path d="M7.075,0.001 L9.281,0.001 L10.240,2.154 L10.763,2.384 L13.014,1.483 L14.607,3.087 L13.760,5.349 L14.061,6.096 L16.000,6.997 L16.000,9.270 L14.061,10.148 L13.822,10.758 L14.652,12.948 L13.109,14.574 L11.036,13.750 L10.095,14.145 L9.270,16.001 L7.053,16.001 L6.251,14.156 L5.359,13.772 L3.320,14.552 L1.760,12.948 L2.563,10.829 L2.340,10.324 L-0.000,9.248 L-0.000,6.997 L2.340,5.920 L2.585,5.371 L1.716,3.076 L3.276,1.483 L5.582,2.384 L6.128,2.176 L7.075,0.001 ZM8.000,5.449 C6.569,5.449 5.410,6.591 5.410,8.001 C5.410,9.412 6.569,10.554 8.000,10.554 C9.431,10.554 10.591,9.412 10.591,8.001 C10.591,6.591 9.431,5.449 8.000,5.449 Z" class="cls-1"/></svg></span>');
            $('#actionMenuDropDown').after('<div id="dropdown-modal"></div>');
        },

        /**
         * Show/hide the "all topics" dropdown for mobile
         */
        mobileDropdown: function () {
            /**
             * Some common stuff used by the topics menu
             */
            var $pdc6   = this.els.$pdc6;
            var $body   = this.els.$body;
            var $menu   = $('#mobile-all-topics');
            var that    = this;
            var loading = false;
            var loaded  = false;
            var classes = {
                activeCategory: 'mobile-topics__category--active',
                loadingTopics: 'mobile-topics--loading'
            };

            /**
             * Looks for the current category and it makes sure
             * that we display it's boards list
             */
            var toggleCurrentCategory = function () {
                var $breadcrumb = $('#topic-select-breadcrumb'),
                    category = '';

                if ($breadcrumb.children().size() == 2) {
                    category = $breadcrumb.find('li:last-child').text();
                } else {
                    category = $('#topic-select-title').find('h3').text();
                }

                $('.mobile-topics__toggle:contains("' + category + '")').click();
            };

            /**
             * Showing/hiding the boards when clicking
             * the category name
             */
            var toggleBoards = function (e) {
                e.preventDefault();

                $(this).parent().toggleClass(classes.activeCategory).siblings().removeClass(classes.activeCategory);
            };

            /**
             * Removing unnecessary stuff from the list and adding what we need
             * in order to make it look good
             */
            var displayCategories = function () {
                var baseClass    = 'mobile-topics';
                var $destination = $('.mobile-topics__list');
                var $chevron     = $destination.children();

                // clearing the destination
                $destination.html('');

                // cleaning all the categories and adding the missing stuff
                $(this).find('.category').each(function () {
                    var $this   = $(this).removeClass('category').addClass(baseClass + '__category');
                    var $name   = $this.find('.name').removeClass('name').addClass(baseClass + '__toggle');
                    var $boards = $this.find('.boards').removeClass('boards').addClass(baseClass + '__boards');

                    // removing unsed stuff
                    $name.find('p').remove();
                    $name.html($name.find('h4').text());
                    $name.append($chevron.clone());
                    $name.click(toggleBoards);

                    $boards.find('a').addClass(baseClass + '__board');
                    $boards.find('.more').remove();

                    $(this).appendTo($destination);
                });

                $menu.removeClass(classes.loadingTopics);

                toggleCurrentCategory();
            };

            /**
             * Loading the categories right from the home page
             */
            var loadCategories = function () {
                if (loading || loaded) return;

                loading = loaded = true;

                var home  = $('#nav-forum').find('a').attr('href');

                $('<div />').load(home + ' #boards-list-public', displayCategories);
            };

            /**
             * Listening for clicks and toggle the
             * visibility of the topics menu
             */
            var toggleMenu = function (e) {
                e.preventDefault();

                var status = !$pdc6.hasClass('with-all-topics');

                $pdc6.toggleClass('with-all-topics');
                common.els.$body.header('toggleBodyOverflow', status);

                if (status) {
                    loadCategories();
                }
            };

            /**
             * Attaching the click listeners
             */
            $('.mobile-topics__close').click(toggleMenu);
            $('#show-all-topics-mobile').click(toggleMenu);
        },

        collapsePopularTopics : function()
        {
            var $popularTopics = $( '#topic-select-topics' )
              , that           = this;

            $( '#toggle-pupular-topics' ).on( 'click', function( e )
            {
                e && e.preventDefault();

                $( this ).toggleClass( 'open' );
                $popularTopics.toggleClass( 'collapsed' );
                that.els.$hero.toggleClass( 'collapsed' ).addClass( 'animate-banner' );

                setTimeout( function()
                {
                    that.els.$hero.removeClass( 'animate-banner' );
                }, 500 );
            } );
        },

        dropdownAllTopics : function()
        {
            $( '#dropdown-all-topics' ).on( 'click', function( e )
            {
                e && e.preventDefault();
            } );
        }

    };

    $.fn.BoardHero = function( options )
    {
        var args     = Array.prototype.slice.call( arguments, 1 )
          , $item    = $( this )
          , instance = $item.data( 'BoardHero' );

        if( !instance )
        {
            instance = new BoardHero( this, options );
            $item.data( 'BoardHero', instance );
        }

        if( typeof options === 'string' )
        {
            instance[ options ].apply( instance, args );
        }

        return this;
    };

} )( jQuery, window, document );
